import { Component, Input } from '@angular/core';

import { TranslatePipe } from '../../../core/i18n/translate.pipe';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="empty-state">
      <div class="empty-state__title">{{ title | t }}</div>

      @if (description) {
        <div class="empty-state__description">{{ description | t }}</div>
      }
    </div>
  `,
  styles: [`
    .empty-state {
      padding: 24px;
      border: 1px dashed #d1d5db;
      border-radius: 12px;
      background: #ffffff;
    }

    .empty-state__title {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
    }

    .empty-state__description {
      margin-top: 8px;
      color: #6b7280;
    }
  `]
})
export class EmptyStateComponent
{
  @Input()
  public title = 'common.noData';

  @Input()
  public description: string | null = null;
}
